<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="endpoint()"
      [chartColumn]="'Product'"
      [hasIndexCol]="!!userId()"
    ></app-api-table>
  }
</app-tab-layout>
